module.exports = __webpack_public_path__ + "img/win-3.34d31581.webp";